// @ts-strict-ignore
export function enumToArray<T1, T2 = string>(enumObject: T1): T2[] {
  return Object.keys(enumObject)
    .filter((key) => isNaN(Number(key)))
    .map((key) => enumObject[key] as T2);
}
